/** Holds Cabin information that appears in basic fare dropdown of "BOOK" navigation on header  */
export interface BrandEntity {
  brandId?: string;
  brandTitle?: string;
}
